import { WalletIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import Link from "next/link";

const EmptyAccountView = () => {
    return (
        <div>
            <div className="w-full rounded-lg p-10">
                <h1 className="mb-6 text-3xl font-medium">
                    Let&apos;s get you started!
                </h1>

                <div className="mb-10 flex w-full flex-col justify-between gap-8 lg:flex-row">
                    <div className="flex flex-col">
                        <div className="mb-2 text-lg font-medium">
                            Add Wallets
                        </div>
                        <p className="mb-4 text-gray-500">
                            Connecting a wallet lets you automatically track
                            transactions and organize your crypto finances for
                            easy bookkeeping and reporting.
                        </p>
                        <Link href="/wallets">
                            <div className="text-[#006BFF]">
                                <div>Let&apos;s go ➔</div>
                                <div className="mt-4 flex justify-center">
                                    <div className="flex size-36 items-center justify-center rounded-full bg-blue-50">
                                        <WalletIcon className="size-24" />
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>

                    <div className="flex flex-col">
                        <div className="mb-2 text-lg font-medium">
                            Add Exchanges
                        </div>
                        <p className="mb-4 text-gray-500">
                            Connecting an exchange lets you automatically import
                            and track your trades, organize them for
                            bookkeeping, and simplifies reporting.
                        </p>
                        <Link href="/exchanges">
                            <div className="text-[#006BFF]">
                                <div>Let&apos;s go ➔</div>
                                <div className="mt-4 flex justify-center">
                                    <div className="flex size-36 items-center justify-center rounded-full bg-blue-50">
                                        <ArrowPathIcon className="size-24" />
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="mt-auto bg-[#F6F6F8] py-4 text-center">
                <span className="text-gray-600">
                    Still got questions? No worries, we can help you getting
                    started in a Demo Call.{" "}
                </span>
                <Link
                    href="https://www.request.finance/demo-accounting"
                    className="font-medium text-[#006BFF]"
                >
                    Book an Appointment
                </Link>
            </div>
        </div>
    );
};

export default EmptyAccountView;
